module.exports = __webpack_public_path__ + "img/TE_Estate_sjkfhkjhrj_2.7521db28.jpeg";